export class FilterPanelViewsMenuClasses {

    static readonly save = "ic3FilterPanelViewsMenu-save";

    static readonly view = "ic3FilterPanelViewsMenu-view";

    static readonly maxViewsReachedText = "ic3FilterPanelViewsMenu-maxViewsReachedText";

    static readonly viewsText = "ic3FilterPanelViewsMenu-viewsText";

    static readonly errorText = "ic3FilterPanelViewsMenu-errorText";

}

export declare type FilterPanelViewsMenuClassesKey = keyof FilterPanelViewsMenuClasses;
